<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardBody>
          <vue-google-heatmap
            :points="points"
            :height="550"
            :lat="-7.600909"
            :lng="111.901173"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import VueGoogleHeatmap from "vue-google-heatmap";
import Vue from "vue";
import { HTTPAUTH } from "../lib/httplib";

Vue.use(VueGoogleHeatmap, {
  apiKey: process.env.VUE_APP_HEATMAP_API_KEY,
});
export default {
  data() {
    return {
      points: [],
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      HTTPAUTH.get("/api/admin/dashboard/heatmap/outlet").then((res) => {
        this.points = res.data.data;
      });
    },
  },
};
</script>